"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    // creates classes from opa1 to opa10
    return {
        scale0: { transform: "scale(0)" },
        scale0_25: { transform: "scale(0.25)" },
        scale0_5: { transform: "scale(0.5)" },
        scale0_75: { transform: "scale(0.5)" },
        scaleQuarter: { transform: "scale(0.25)" },
        scaleHalf: { transform: "scale(0.5)" },
        scaleThreeQuarters: { transform: "scale(0.5)" },
        scale1: { transform: "scale(1)" },
        scale2: { transform: "scale(2)" },
        scale3: { transform: "scale(3)" },
        scale4: { transform: "scale(4)" },
        rotateX90: { transform: "rotateX(90deg)" },
        rotateX180: { transform: "rotateX(180deg)" },
        rotateX270: { transform: "rotateX(270deg)" },
        flipH: {
            transform: "scaleX(-1)",
            filter: "FlipH"
        },
        flipV: {
            transform: "scaleY(-1)",
            filter: "FlipV"
        },
        scaleX0: { transform: "scaleX(0)" },
        scaleX0_25: { transform: "scaleX(0.25)" },
        scaleX0_5: { transform: "scaleX(0.5)" },
        scaleX0_75: { transform: "scaleX(0.5)" },
        scaleXQuarter: { transform: "scaleX(0.25)" },
        scaleXHalf: { transform: "scaleX(0.5)" },
        scaleXThreeQuarters: { transform: "scaleX(0.5)" },
        scaleX1: { transform: "scaleX(1)" },
        scaleX2: { transform: "scaleX(2)" },
        scaleX3: { transform: "scaleX(3)" },
        scaleX4: { transform: "scaleX(4)" },
        scaleY0: { transform: "scaleY(0)" },
        scaleY0_25: { transform: "scaleY(0.25)" },
        scaleY0_5: { transform: "scaleY(0.5)" },
        scaleY0_75: { transform: "scaleY(0.5)" },
        scaleYQuarter: { transform: "scaleY(0.25)" },
        scaleYHalf: { transform: "scaleY(0.5)" },
        scaleYThreeQuarters: { transform: "scaleY(0.5)" },
        scaleY1: { transform: "scaleY(1)" },
        scaleY2: { transform: "scaleY(2)" },
        scaleY3: { transform: "scaleY(3)" },
        scaleY4: { transform: "scaleY(4)" }
    };
});
//# sourceMappingURL=Transform.js.map